import React, { useEffect } from "react";
import { Trans, useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import { Link } from "react-router-dom";
import ContactForm from "../components/ContactForm";
import FAQ from "../components/FAQ";

const Contact = () => {
  const { t } = useTranslation();
  const location = useLocation();

  useEffect(() => {
    // Scroll to the correct section if a hash exists in the URL
    if (location.hash) {
      const element = document.getElementById(location.hash.replace("#", ""));
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    } else {
      // If no hash, scroll to top
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }, [location]);

  return (
    <div className="min-h-screen w-full flex justify-center items-center py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-5xl items-center">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-[1fr_1.3fr] h-full space-y-10 sm:space-y-0 sm:space-x-10 justify-between md:my-20">
          {/* Intro Section */}
          <div className="flex flex-col">
            <h1 className="font-bold text-4xl mb-4">{t("contact_us")}</h1>
            <p className="mb-6 text-md">
              <Trans
                i18nKey="contact_introduction"
                components={{
                  a: <a href="#faq" />,
                }}
              >
                {t("contact_introduction")}
              </Trans>
            </p>
            <div className="flex flex-col space-y-1.5 mt-8">
              {/* Company information */}
              <h2 className="text-2xl font-bold">{t("company.information")}</h2>
              <p className="text-lg">
                <strong>{t("company.name")}</strong>
              </p>
              <p>
                <span className="font-semibold">
                  {t("company.reg_no_title")}{" "}
                </span>
                {t("company.reg_no")}
              </p>
              {/* <p>
                <span className="font-semibold">
                  {t("company.phone_title")}{" "}
                </span>
                <Trans
                  i18nKey="company.customer_phone"
                  components={{
                    a: <a href="tel:+46707216910" />,
                  }}
                >
                  {t("company.phone")}
                </Trans>
              </p> */}
              <p>
                <span className="font-semibold">
                  {t("company.address_title")}{" "}
                </span>
                {t("company.address")}
              </p>
              <p>
                <span className="font-semibold">
                  {t("company.email_title")}
                </span>
                <Trans
                  i18nKey="company.customer_email"
                  components={{
                    a: (
                      <a href="mailto:kundtjanst@tuutuum.se">
                        {t("company.customer_email")}
                      </a>
                    ),
                  }}
                >
                  {t("company.customer_email")}
                </Trans>
              </p>
            </div>
          </div>

          {/* Contact Form */}
          <ContactForm />
        </div>

        <hr className="max-w-screen-xl mx-auto my-10 border-teal-300" />

        {/* FAQ */}
        <div id="faq" className="mt-12 max-w-4xl mx-auto mb-5">
          <FAQ />
        </div>
      </div>
    </div>
  );
};

export default Contact;
